import { Button, Divider, Image, Row, Tooltip, message } from "antd";
import classNames from "classnames";
import styles from "./index.less";
import { StreamResponseDataType } from "@/FlowEditPage/utils/streamFetch";
import { useMemo } from "react";
import { ReactComponent as RefreshIcon } from "../../assets/refresh.svg";
import { ReactComponent as CopyIcon } from "../../assets/copy2.svg";
// import { ReactComponent as DeleteIcon } from '@/assets/delete.svg';
import { copyData } from "@packages/utils";
import { ChatMessageType } from "../types";
import FileMessage from "../messages/File";
import VoiceMessage from "../messages/VoiceMessage";

type ChatItemHumanProps = {
  msg: ChatMessageType;
  loading: boolean;
  onRefresh: () => void;
  streamResponseData?: StreamResponseDataType[];
  onViewDetail: () => void;
  onDelete: () => void;
};

const ChatItemHuman = ({
  msg,
  loading,
  onRefresh,
  onViewDetail,
  streamResponseData,
}: // onDelete,
ChatItemHumanProps) => {
  const totalTime = useMemo(() => {
    if (streamResponseData) {
      const maxEndTime = Math.max(
        ...streamResponseData.map((d) => d.endTime).filter((d) => !!d)
      );
      const minBeginTime = Math.min(
        ...streamResponseData.map((d) => d.beginTime).filter((d) => !!d)
      );

      if (
        Math.abs(maxEndTime) === Infinity ||
        Math.abs(minBeginTime) === Infinity
      )
        return 0;

      const time = (maxEndTime - minBeginTime) / 1000;
      return time;
    }
    return 0;
  }, [streamResponseData]);

  function renderMsg() {
    switch (msg.type) {
      case "text":
        return msg.messageOutput;
      case "image":
        return <Image src={msg.url} className={styles.img} />;
      case "file":
        return <FileMessage msg={msg} />;
      case "video":
        return <video src={msg.url} controls className={styles.video} />;
      case "voice":
        return <VoiceMessage url={msg.url} />;
      default:
        return null;
    }
  }

  return (
    <div className={classNames(styles["chat-item-human"], styles["chat-item"])}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
        className={styles["message-box"]}
      >
        <div className={styles["chat-item-human-content"]}>
          <div className={styles["chat-text"]}>
            {renderMsg()}
            {!loading && streamResponseData && (
              <>
                <Divider style={{ margin: "7px 0" }} />
                <Row justify="end">
                  <span className={styles.time}>{`${totalTime}s`}</span>
                  <a className={styles.tag} onClick={onViewDetail}>
                    查看详情
                  </a>
                </Row>
              </>
            )}
            {loading && (
              <>
                <Divider style={{ margin: "7px 0" }} />
                <div className={styles.loading}>
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                </div>
              </>
            )}
          </div>
        </div>
        <div className={styles["action-area"]}>
          <Tooltip title="重新生成" placement="bottom">
            <Button type="text" icon={<RefreshIcon />} onClick={onRefresh} />
          </Tooltip>
          <Tooltip title="复制" placement="bottom">
            <Button
              type="text"
              icon={<CopyIcon />}
              onClick={async () => {
                if (msg.type === "text") {
                  await copyData(msg.messageOutput);
                  message.success("复制成功");
                }
              }}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default ChatItemHuman;
